import { useSession } from 'providers';
import { SESSION_STATE } from 'providers/SessionProvider/sessionProvider.constants';
import {
  Children,
  cloneElement,
  isValidElement,
  PropsWithChildren,
  useEffect,
  useState,
} from 'react';

export const PaginatedRoute = ({ children }: PropsWithChildren) => {
  const [rerenderKey, setRerenderKey] = useState(0);
  const { sessionState } = useSession();

  useEffect(() => {
    if (sessionState === SESSION_STATE.AUTHENTICATED) {
      setRerenderKey((prevKey) => prevKey + 1);
    }
  }, [sessionState]);

  if (!children) {
    return <>{children}</>;
  }

  const child = Children.only(children);

  if (!isValidElement(child)) {
    return <>{children}</>;
  }

  return <>{cloneElement(child, { key: rerenderKey })}</>;
};
